import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import RioHome from './Components/RioHome';

function App() {
  return (
    <div className="App">
      <RioHome/>
    </div>
  );
}

export default App;
